import { API_AUTH } from "../common";

const BaoCaoChiNhanhApi = {

    PhanQuyenBaoCaoTongQuan: () =>
        API_AUTH.get(
            `bao-cao-tong-quan/phan-quyen-bao-cao-tong-quan`,
            {}
        ),

    DanhSachCuaHang: () =>
        API_AUTH.get(
            `bao-cao-tong-quan/danh-sach-cua-hang`,
            {}
        ),

    ThongKeHopDong: () =>
        API_AUTH.get(
            `bao-cao-tong-quan/thong-ke-hop-dong`,
            {}
        ),

    ThongKeHuyDongVon: () =>
        API_AUTH.get(
            `bao-cao-tong-quan/thong-ke-huy-dong-von`,
            {}
        ),

    ThongKeDongTien: () =>
        API_AUTH.get(
            `bao-cao-tong-quan/thong-ke-dong-tien`,
            {}
        ),

    ThongKeDuNoChoVay: () =>
        API_AUTH.get(
            `bao-cao-tong-quan/thong-ke-du-no-cho-vay`,
            {}
        ),

    BieuDoLoiNhuan: (nam) =>
        API_AUTH.get(
            `bao-cao-tong-quan/bieu-do-loi-nhuan?nam=${nam}`,
            {}
        ),
    BieuDoLoiNhuanTheoCuaHang: (nam, comcode) =>
        API_AUTH.get(
            `bao-cao-tong-quan/bieu-do-loi-nhuan-theo-cua-hang?nam=${nam}&comCode=${comcode}`,
            {}
        ),

    BieuDoHopDong: (nam) =>
        API_AUTH.get(
            `bao-cao-tong-quan/bieu-do-hop-dong?nam=${nam}`,
            {}
        ),
};

export default BaoCaoChiNhanhApi;
